
import api from "./api"

export const get_distance_data = async(payload) => {
    // console.log("Payload =>", payload)
    try{
        const response = await api.post('/get_distance_for_delivery',payload)
        // console.log(response.data.data)
        return response.data.data
    }
    catch(error){
        throw new Error(error)
    }
}